import { FREQUENCIES, CALENDAR_FREQUENCIES, MODES } from './constants';
import { parseWeekdaysArray } from './weekdays';

export const LEGACY_FREQUENCY_MAP = Object.freeze({
  biweekly: { frequency: 'weekly', interval: 2 },
  quarterly: { frequency: 'monthly', interval: 3 },
  semiannual: { frequency: 'monthly', interval: 6 },
});

export const INTERVAL_FREQUENCIES = Object.freeze(['daily', 'weekly', 'monthly', 'yearly']);

export const DEFAULT_INTERVAL = 1;
export const MIN_INTERVAL = 1;
export const MAX_INTERVAL = 999;

export function parseInterval(value) {
  if (value == null || value === '') return DEFAULT_INTERVAL;
  const n = Number(value);
  if (!Number.isInteger(n) || n < MIN_INTERVAL || n > MAX_INTERVAL) return null;
  return n;
}

/**
 * Normalize legacy frequencies and ensure interval on canonical rules.
 */
export function canonicalizeRepeatRule(rule) {
  if (rule == null || typeof rule !== 'object' || Array.isArray(rule)) return rule;

  let frequency = String(rule.frequency || '').trim().toLowerCase();
  if (!frequency || frequency === 'never') return null;

  let interval = rule.interval;
  const legacy = LEGACY_FREQUENCY_MAP[frequency];
  if (legacy) {
    frequency = legacy.frequency;
    interval = legacy.interval;
  }

  if (!FREQUENCIES.includes(frequency) || frequency === 'never') {
    return rule;
  }

  const parsedInterval = parseInterval(interval);
  const out = { frequency, interval: parsedInterval != null ? parsedInterval : DEFAULT_INTERVAL };

  if (frequency === 'weekly') {
    const weekdays = parseWeekdaysArray(rule.weekdays);
    if (weekdays && weekdays.length > 0) {
      out.weekdays = weekdays;
    }
  }

  if (CALENDAR_FREQUENCIES.includes(frequency)) {
    const mode = MODES.includes(rule.mode) ? rule.mode : 'dayOfMonth';
    out.mode = mode;
    if (mode === 'dayOfMonth' && Number.isInteger(rule.dayOfMonth)) {
      out.dayOfMonth = rule.dayOfMonth;
    }
    if (mode === 'nthWeekday') {
      if (rule.nth === 'last' || [1, 2, 3, 4].includes(rule.nth)) out.nth = rule.nth;
      if (Number.isInteger(rule.weekday) && rule.weekday >= 0 && rule.weekday <= 6) {
        out.weekday = rule.weekday;
      }
    }
  }

  return out;
}
